// extracted by mini-css-extract-plugin
export default {"addresses":"ValidatorAddresses_addresses__QkPH+","item":"ValidatorAddresses_item__gdF5V"};